import React, { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';

import { Button, Column, Table, Switch } from '@tencent/spaui';

import { RPCFactory } from '../../../utils/RequestUtil';
import { DimensionMap } from './config';
import { scopeMap } from '../../pages/setting/clue/config';

import useDialog from '../../hooks/useDialog';
import useContentDialog from '../../hooks/useContentDialog';
import useFeedback from '../../hooks/useFeedback';

import SettingDialog from './settingDialog';
import DetailDialog from './components/detailDialog';
import TestDialog from './components/testDialog';
import Feedback from '../../common/feedback';
import PrivilegeCode from '../../../consts/PrivilegeCode';

const MyTable = (props) => {
  const canEditPushRule = window.pageProps.privileges.includes(PrivilegeCode.LEADS_PUSH_RULE_EDIT.getCode());

  const [datalist, setDatalist] = useState([]);
  const [flag, setFlag] = useState(0);

  const [showDetail, setShowDetail] = useState(false);
  const [detail, setDetail] = useState({});

  const settingDialogHooks = useDialog({
    showDialog: false,
  });

  const detailDialogHooks = useContentDialog({
    showDialog: false,
  });

  const testDialogHooks = useContentDialog({
    showDialog: false,
  });

  const feedbackHooks = useFeedback();

  const { showDialog, setShowDialog, model, showAsEditModel, showAsAddModel, showAsCopyModel } = settingDialogHooks;

  useEffect(() => {
    RPCFactory.leadsPushRule
      .getAll()
      .done((data) => {
        setDatalist(data.entities);
      })
      .fail((code, msg) => {
        feedbackHooks.showErrorTip(msg);
      });
  }, [flag]);

  const columnOperatorRender = useCallback((type, name, value, data) => {
    if (type == 'head') {
      return <span>操作</span>;
    }
    return (
      <div>
        <a
          style={{ cursor: 'pointer' }}
          onClick={() => {
            detailDialogHooks.openDialog(data);
          }}
          className="a-table-action"
        >
          查看详情
        </a>
        {canEditPushRule && (
          <a
            style={{ cursor: 'pointer' }}
            onClick={(e) => {
              showAsCopyModel(data);
            }}
            className="a-table-action"
          >
            复制新建
          </a>
        )}
        <a
          style={{ cursor: 'pointer' }}
          onClick={() => {
            testDialogHooks.openDialog(data);
          }}
          className="a-table-action"
        >
          推送测试
        </a>
        {canEditPushRule && (
          <a
            style={{ cursor: 'pointer' }}
            onClick={(e) => {
              showAsEditModel(data);
            }}
            className="a-table-action"
          >
            编辑
          </a>
        )}
      </div>
    );
  }, []);

  const renderDimension = useCallback((type, name, value, data) => {
    if (type == 'head') {
      return value;
    }
    if (data.applyRange.applyRangeType == 'ALL') {
      return DimensionMap.ALL;
    }
    let res = '';
    data.applyRange.applyRangeDetail.forEach((field) => {
      const key = field.fieldName;
      if (field.fieldScope == 'BUNDLE') {
        res = ` ${res}${key} `;
      } else {
        res = ` ${res}${DimensionMap[key] || scopeMap[key]} `;
      }
    });
    return res;
  }, []);

  const renderPauseControl = (type, name, value, data) => {
    if (type == 'head') {
      return value;
    }
    const isChecked = value == 0;

    return (
      <div>
        <Switch
          checked={isChecked}
          onChange={(e, value) => {
            onSwitchChange(e, value, data.ruleId);
          }}
        />
        {isChecked ? '已启动' : '已暂停'}
      </div>
    );
  };

  const onSwitchChange = (e, value, ruleId) => {
    switchStatus(ruleId, value);
    RPCFactory.leadsPushRule
      .pause({
        ruleId,
        pauseStatus: value ? 0 : 1,
      })
      .done((data) => {})
      .fail((ret, msg) => {
        switchStatus(ruleId, !value);
        feedbackHooks.showErrorTip(`更改状态失败:${msg}`);
      });
  };

  const switchStatus = (id, value) => {
    const _datalist = _.cloneDeep(datalist);

    _datalist.forEach((e) => {
      if (e.ruleId == id) {
        e.pauseStatus = value ? 0 : 1;
      }
    });

    setDatalist(_datalist);
  };

  const handleShowDetail = (data) => {
    setDetail(data);
    setShowDetail(true);
  };

  const handleSubmit = (data) => {
    let promise = RPCFactory.leadsPushRule.add;
    if (model == 'edit') {
      promise = RPCFactory.leadsPushRule.update;
    }

    promise(data)
      .done(() => {
        setFlag(flag + 1);
        setShowDialog(false);
      })
      .fail((code, msg) => {
        feedbackHooks.showErrorTip(msg);
      });
  };

  return (
    <div className="apppush">
      <div className="dialog-title">
        <div>
          <h3 className="dialog-title-name">推送接口配置</h3>
          <p className="title-tips">您可以设置多个推送接口配置方案，系统将按配置方案把适用的线索推送至Http_post_url</p>
        </div>
        {canEditPushRule && (
          <div className="title-right">
            <Button
              displayType="primary"
              onClick={() => {
                showAsAddModel();
              }}
            >
              新建配置
            </Button>
          </div>
        )}
      </div>
      <div className="datarea">
        <div className="datalist">
          <Table data={datalist} bordered={false}>
            <Column name="ruleName">规则名称</Column>
            <Column name="leadsPushUrl" className="col-url">
              推送地址
            </Column>
            <Column name="applyRange" render={renderDimension}>
              适用范围
            </Column>
            <Column name="pauseStatus" render={renderPauseControl}>
              是否启用
            </Column>
            <Column name="operation" render={columnOperatorRender}>
              操作
            </Column>
          </Table>
        </div>
      </div>
      {showDialog ? (
        <SettingDialog
          {...settingDialogHooks}
          show={showDialog}
          onSubmit={handleSubmit}
          onInVaild={(msg) => {
            feedbackHooks.showErrorTip(msg);
          }}
        />
      ) : null}
      {detailDialogHooks.show ? <DetailDialog {...detailDialogHooks}></DetailDialog> : null}
      {testDialogHooks.show ? <TestDialog {...testDialogHooks} /> : null}
      <Feedback {...feedbackHooks} />
    </div>
  );
};

export default MyTable;
